// @flow

// $FlowFixMe Flow v0.104.0 upgrade supression.
export default (...args: *) => {};
